import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Brand";

const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 bg-[#040810] py-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Wordmark className="h-12 mb-6" />
            <p className="text-slate-400 text-sm max-w-sm leading-relaxed">
              ClydeFlow is the AI automation suite for solo-founders and local
              business owners. Built in Glasgow. Designed to execute.
            </p>
            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">
              © {new Date().getFullYear()} ClydeFlow Ltd. All rights reserved.
            </p>
          </div>

          <div>
            <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-400 mb-4">
              Product
            </h4>
            <ul className="space-y-3 text-sm">
              <li><a data-testid="footer-link-features" href="#features" className="text-slate-300 hover:text-white">Features</a></li>
              <li><a data-testid="footer-link-pricing" href="#pricing" className="text-slate-300 hover:text-white">Pricing</a></li>
              <li><a data-testid="footer-link-faq" href="#faq" className="text-slate-300 hover:text-white">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-400 mb-4">
              Company
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-privacy" to="/privacy" className="text-slate-300 hover:text-white">Privacy</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" className="text-slate-300 hover:text-white">Terms</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="text-slate-300 hover:text-white">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
            Made in Glasgow · Shipped worldwide
          </p>
          {/* Google Preferred Sources — prominent footer placement */}
          <div
            google-add-preferred-source-btn=""
            data-testid="google-preferred-source-footer"
            className="flex items-center justify-center"
          />
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
            Execution Over Ideation™
          </p>
        </div>

        <div
          className="mt-8 pt-6 border-t border-white/5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600"
          data-testid="footer-network-strip"
        >
          <span>Part of the ClydeFlow Network</span>
          <span className="text-slate-700">·</span>
          <a
            href="https://instavibe.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-network-instavibe"
            className="text-slate-400 hover:text-cyan-300 transition-colors"
          >
            Instavibe
          </a>
          <span className="text-slate-700">·</span>
          <a
            href="https://klayvex.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-network-klayvex"
            className="text-slate-400 hover:text-cyan-300 transition-colors"
          >
            Klayvex
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
